import type { CSSProperties } from 'react';

import type { GeoType } from '../../../../api/regions';

interface AreaLike {
  geoType: GeoType;
  geoRef: string;
  label: string;
}

interface Props {
  areas: AreaLike[];
  color: string;
  emptyText?: string;
}

const chipStyle = (color: string): CSSProperties => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 9px',
  borderRadius: 8,
  border: `1px solid ${color}`,
  background: 'var(--nb-surface)',
  fontSize: 12,
});

/** Read-only chips for the areas (states/counties/cities) that make up a region. */
export function RegionAreaChips({ areas, color, emptyText }: Props) {
  if (areas.length === 0) {
    return (
      <span style={{ fontSize: 12.5, color: 'var(--nb-subtle)' }}>
        {emptyText ?? 'No areas yet.'}
      </span>
    );
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {areas.map((a) => (
        <span key={`${a.geoType}:${a.geoRef}`} style={chipStyle(color)}>
          <span className="nb-eyebrow" style={{ fontSize: 8.5, color: 'var(--nb-faint)' }}>
            {a.geoType}
          </span>
          <span style={{ color: 'var(--nb-ink)', fontWeight: 600 }}>{a.label}</span>
        </span>
      ))}
    </div>
  );
}
